export const PLAN_COOKIE_CLEAR_NAME = 'clearAllRead';
